<template>
  <div class="container-fluid">
    <ValidationObserver ref="form">
      <div class="row">
        <div class="col-12 col-md-2">
          <div class="font-weight-normal">
            Compra:
          </div>
          <div class="align-items-end d-flex p-0 pt-2 custom-radio-container">
            <CustomRadio
              ref="compra"
              :name="`compra_${value.bookId}`"
              :is-disabled="false"
              :change-event="onChangeCompra"
              :options="optionsYesNoList"
              :is-question-list="true"
              :error="!purchaseSelected"
              :custom-error-msg="resources['R03200183'] || ''"
            />
          </div>
        </div>

        <div class="col-12 col-md-10 mt-auto">
          <div class="row">
            <!-- Razón -->
            <div class="col-12 col-md-6 pt-3 pt-md-0">
              <div v-if="showPurchaseReason">
                <div class="font-weight-normal">
                  Razón:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="`${model.purchase != null ? 'required' : ''}`"
                >
                  <custom-drop-down
                    v-model="model.purchaseReason"
                    class="pt-2"
                    :name="`razon_${value.bookId}`"
                    fieldkey="id"
                    fieldname="value"
                    :clearable="false"
                    :options="purchaseReasonOptions"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25045']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Razón -->

            <!-- Centro -->
            <div
              v-if="showPurchaseReason && showCenterDropdown"
              class="col-12 col-md-6 pt-3 pt-md-0"
            >
              <div>
                <div class="font-weight-normal">
                  Centro:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showCenterDropdown ? 'required' : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.center"
                    class="pt-2"
                    :name="`center_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="filteredCenters"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25048']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Centro -->

            <!-- Municipio -->
            <div class="col-12 col-md-6 pt-3 pt-md-0">
              <div v-if="showPurchaseReason && showMunicipalitySchool">
                <div class="font-weight-normal">
                  Municipio:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showMunicipalitySchool
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.municipality"
                    class="pt-2"
                    :name="`municipality_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="municipalities"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25046']"
                    @input="onMunicipalityChanged"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Municipio -->

            <!-- Escuela -->
            <div class="col-12 col-md-6 pt-3">
              <div v-if="showPurchaseReason && showMunicipalitySchool">
                <div class="font-weight-normal">
                  Escuela:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showMunicipalitySchool
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.school"
                    class="pt-2"
                    :name="`school_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="filteredSchools"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25047']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Escuela -->

            <!-- Acciones -->
            <div
              class="justify-content-md-end mt-auto pt-3"
              :class="showCenterDropdown ? 'col-12' : 'col-12 col-md-6'"
            >
              <div
                :class="[
                  'row buttons-mobile justify-content-end',
                  { 'pl-4': !isMobile },
                ]"
              >
                <div :class="{ 'col pr-0': isMobile }">
                  <ActionButton
                    class="mr-2 btn-transparent lg-btn"
                    variant="outline-danger"
                    text="Cancelar"
                    i="fas fa-times-circle mx-auto"
                    @click="cancel"
                  />
                </div>
                <div :class="{ 'col pl-1': isMobile }">
                  <ActionButton
                    class="mr-2 lg-btn"
                    variant="success"
                    text="Guardar"
                    i="fas fa-save mx-auto"
                    @click="save"
                  />
                </div>
              </div>
            </div>
            <!-- Acciones -->
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomRadio from 'custom-radio';
import ActionButton from 'ActionButton';
import purchaseReasonsConst from '@/utils/constants/book/purchaseReasons';
import locationService from '@/services/api/location.api.js';
import resourcesService from '@/services/resources.js';
import alert from '@/mixin/alert.mixin';
import { determineBook } from '@/modules/books-requests/api';
import {
  studentBookStatus,
  studentBookStatusString,
} from '@/utils/constants/book/studentBookStatus';
import purchaseReasonsDesc from '@/utils/constants/book/purchaseReasonsDesc.js';

export default {
  name: 'DetermineBook',
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    CustomRadio,
    ActionButton,
  },
  data() {
    return {
      optionsYesNoList: [
        {
          id: true,
          name: 'question1',
          label: 'Sí',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: false,
          name: 'question2',
          label: 'No',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
      purchaseSelected: true,
      resources: [],
      schools: [],
      municipalities: [],
      model: {
        purchaseFlag: null,
        purchase: null,
        purchaseReason: null,
        center: null,
        school: null,
        municipality: null,
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    showCenterDropdown() {
      return (
        this.model.purchaseReason &&
        this.model.purchaseReason?.id ==
          purchaseReasonsConst.IntercambioDeCentro
      );
    },
    showMunicipalitySchool() {
      return (
        this.model.purchaseReason &&
        this.model.purchaseReason?.id ==
          purchaseReasonsConst.IntercambioDeEscuela
      );
    },
    showPurchaseReason() {
      return this.model.purchase == false;
    },
    purchaseReasonOptions() {
      return purchaseReasonsDesc;
    },
    filteredCenters() {
      const centers = this.collections.centers.filter(
        (x) => x.id !== this.value.cseeId
      );

      return centers;
    },
    filteredSchools() {
      const schools = this.schools.filter((x) => x.id !== this.value.schoolId);

      return schools;
    },
  },
  watch: {
    'model.purchaseReason'(val) {
      if (val.id === 0) {
        this.model.municipality = null;
        this.model.school = null;
      } else if (val.id === 1) {
        this.model.center = null;
        this.getMunicipalities();
      } else {
        this.model.center = null;
        this.model.municipality = null;
        this.model.school = null;
      }
    },
  },
  methods: {
    onChangeCompra(item) {
      this.model.purchaseFlag = item.id;
      if (item.id) {
        this.model.purchaseReason = null;
        this.model.center = null;
        this.model.municipality = null;
        this.model.school = null;
        this.model.purchaseReason = null;
      }

      this.purchaseSelected = true;
      this.model.purchase = item.id;
    },
    async onMunicipalityChanged(municipality) {
      if (municipality) {
        const { data } = await locationService.getSchools({
          academicYearId: this.value.academicYearId,
          municipalityId: this.model.municipality.id,
        });
        this.schools = data;
      }
    },
    async getMunicipalities() {
      const { data } = await locationService.getMunicipalities({
        centerId: this.value.cseeId,
        academicYearId: this.value.academicYearId,
      });
      this.municipalities = data;
    },
    async save() {
      this.purchaseSelected = this.model.purchase != null;
      const valid = await this.$refs.form.validate();
      if (this.purchaseSelected && valid) {
        const book = {
          bookId: this.value.bookId,
          academicYearId: this.value.academicYearId,
          studentSieId: this.value.studentSieId,
          purchaseFlag: this.model.purchaseFlag,
          purchaseReasonId: this.model.purchaseReason?.id ?? null,
          purchaseCenterId: this.model.center?.id ?? null,
          purchaseLocationSchoolId: this.model.school?.id ?? null,
        };

        let nextStatus = '';
        if (
          this.model.purchase &&
          this.value.statusId == studentBookStatus.PedienteDeterminacionCSEE
        ) {
          book.targetStatusId = studentBookStatus.PedienteDeterminacionSAEE;
          nextStatus = studentBookStatusString.PedienteDeterminacionSAEE;
        } else if (
          this.model.purchase &&
          this.value.statusId == studentBookStatus.PedienteDeterminacionSAEE
        ) {
          book.targetStatusId = studentBookStatus.PendienteCompra;
          nextStatus = studentBookStatusString.PendienteCompra;
        } else if (
          this.model.purchaseReason.id ==
          purchaseReasonsConst.IntercambioDeCentro
        ) {
          book.targetStatusId = studentBookStatus.PendienteEntregaCSEE;
          nextStatus = studentBookStatusString.PendienteEntregaCSEE;
        } else if (
          this.model.purchaseReason.id ==
          purchaseReasonsConst.InventarioDeEscuela
        ) {
          book.targetStatusId = studentBookStatus.PendienteEntregaEstudiante;
          nextStatus = studentBookStatusString.PendienteEntregaEstudiante;
        } else {
          book.targetStatusId = studentBookStatus.PendienteEntregaEscuela;
          nextStatus = studentBookStatusString.PendienteEntregaEscuela;
        }

        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea poder cambiar el estatus de ${this.value.status} a ${nextStatus}?`
        );
        if (answer) {
          determineBook(book)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Los datos fueron guardados exitosamente.',
                  'success'
                );
                this.refreshSearch();
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        }
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada',
          'error'
        );
      }
    },
    refreshSearch() {
      this.$emit('success-determine-book');
      this.cancel();
    },
    cancel() {
      this.$emit('cancel-determine-book');
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200183',
        '25045',
        '25046',
        '25047',
        '25048',
      ]);
      this.getMunicipalities();
    },
  },
  async mounted() {
    await this.loadResources();
  },
};
</script>

<style scoped>
@media only screen and (max-width: 375px) {
  .buttons-mobile {
    display: flex;
  }

  .lg-btn {
    width: 100%;
  }
}
</style>
